import { render, staticRenderFns } from "./stk_barin.vue?vue&type=template&id=fedf4202&scoped=true"
import script from "./stk_barin.vue?vue&type=script&lang=js"
export * from "./stk_barin.vue?vue&type=script&lang=js"
import style0 from "./stk_barin.vue?vue&type=style&index=0&id=fedf4202&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fedf4202",
  null
  
)

export default component.exports